module.exports = __webpack_public_path__ + "static/img/china-2.1bce557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-2.png
// module id = 1384
// module chunks = 1